import { useEffect, useState } from 'react'
import {
  faAngular,
  faCss3,
  faGitAlt,
  faHtml5,
  faJsSquare,
  faBootstrap,
  faSass,
  faStripe,
  faNodeJs,
  faDocker,
  faGithubSquare,
  faAws,
  faReact,
} from '@fortawesome/free-brands-svg-icons'
import Loader from 'react-loaders'
import AnimatedLetters from '../AnimatedLetters'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './index.scss'
import useWindowDimensions from '../hooks/useWindowDimensions'

const About = () => {
  const [letterClass, setLetterClass] = useState('text-animate')

  const { width } = useWindowDimensions()

  useEffect(() => {
    return setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 3000)
  }, [])

  return (
    <>
      <div className={`container about-page ${width < 768 ? 'my-20' : ''} `}>
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={['A', 'b', 'o', 'u', 't', ' ', 'm', 'e']}
              idx={15}
            />
          </h1>
          <p>
            I'm a very ambitious software engineer with strong knowledge in
            developing customer-facing applications. I will like to contribute
            and put my skill to use at a forward-thinking company on challenging
            and diverse projects.
          </p>
          <p align="LEFT">
            I'm quiet confident, naturally curious, and perpetually working on
            improving my skill set and willing to learn new to solve one problem
            at a time.
          </p>
          <p>
            If I need to define myself in one sentence that would be a family
            person, father, a sports fanatic, social butterfly, and
            tech-obsessed!!!
          </p>
        </div>

        <div
          style={{ height: '100%', display: 'flex', justifyContent: 'center' }}
        >
          <div className="stage-cube-cont stage-cube-cont_1st">
            <div className="cubespinner">
              <div className="face1">
                <FontAwesomeIcon icon={faHtml5} color="#F06529" />
              </div>
              <div className="face2">
                <FontAwesomeIcon icon={faCss3} color="#28A4D9" />
              </div>
              <div className="face3">
                <FontAwesomeIcon icon={faReact} color="#5ED4F4" />
              </div>
              <div className="face4">
                <FontAwesomeIcon icon={faJsSquare} color="#EFD81D" />
              </div>
              {/* <div className="face5">
              <FontAwesomeIcon icon={faDocker} color="#EFD81D" />
            </div> */}
              <div className="face5">
                <FontAwesomeIcon icon={faGitAlt} color="#EC4D28" />
              </div>
              <div className="face6">
                <FontAwesomeIcon icon={faBootstrap} color="#EC4D28" />
              </div>
            </div>
          </div>

          <div className="stage-cube-cont stage-cube-cont_2nd">
            <div className="cubespinner">
              <div className="face1">
                <FontAwesomeIcon icon={faNodeJs} color="#F06529" />
              </div>
              <div className="face2">
                <FontAwesomeIcon icon={faAngular} color="#28A4D9" />
              </div>
              <div className="face3">
                <FontAwesomeIcon icon={faStripe} color="#5ED4F4" />
              </div>
              <div className="face4">
                <FontAwesomeIcon icon={faAws} color="#EFD81D" />
              </div>
              <div className="face5">
                <FontAwesomeIcon icon={faGithubSquare} color="#EC4D28" />
              </div>
              <div className="face6">
                <FontAwesomeIcon icon={faDocker} color="#EC4D28" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Loader type="pacman" />
    </>
  )
}

export default About
